module.exports = __webpack_public_path__ + "static/media/mvp.da8ce8ba.jpg";